import useApi from 'Lib/hooks/useApi';

import AsyncFilter from './AsyncFilter';

export default function PostingSetting(props) {
    const fetchSettings = useApi(props.api.getPostingSettings);

    const getOptions = () => {
        return new Promise(resolve => {
            fetchSettings({ postingSettingIDs: Array.isArray(props.value) ? props.value : [props.value] }).then(response => {
                const defaults = response.data.map(({ postingSetting }) => ({
                    label: postingSetting.name,
                    value: postingSetting.postingSettingID
                }));
                resolve(defaults);
            });
        });
    };

    const createOption = item => {
        return { label: item.postingSetting.name, value: item.postingSetting.postingSettingID };
    };

    return (
        <AsyncFilter
            multiple={props.multi}
            value={props.value}
            label={props.label}
            placeholder="Type to search setting"
            optionPath="postingSetting.postingSettingID"
            fetch={fetchSettings}
            getDefaultOptions={getOptions}
            createOption={createOption}
            onChange={(__, options) => {
                let selected = options;
                if (options) selected = Array.isArray(options) ? options.map(option => option.value) : [options.value];
                props.onChange('postingSettingIDs', selected);
            }}
        />
    );
}
